import { render, staticRenderFns } from "./JSelectBizComponentModal.vue?vue&type=template&id=371c6e8a&scoped=true&"
import script from "./JSelectBizComponentModal.vue?vue&type=script&lang=js&"
export * from "./JSelectBizComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./JSelectBizComponentModal.vue?vue&type=style&index=0&id=371c6e8a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371c6e8a",
  null
  
)

export default component.exports